import { render } from "./DragAndDropForm.vue?vue&type=template&id=6371c7af&scoped=true"
import script from "./DragAndDropForm.vue?vue&type=script&lang=js"
export * from "./DragAndDropForm.vue?vue&type=script&lang=js"

import "./DragAndDropForm.vue?vue&type=style&index=0&id=6371c7af&scoped=true&lang=css"

import exportComponent from "/builds/mobiustech/fileuploadservice/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6371c7af"]])

export default __exports__